import React, { Component } from 'react';
import { CardBody, Collapse } from 'reactstrap';
import propTypes from 'prop-types';

import SearchForm from './SearchForm';
import SortForm from './SortForm';
import FilterForm from './FilterForm';
// import FilterForm from './FilterForm';

export default class Filters extends Component {
  constructor(props){
    super(props);
    this.state = {
      keyword: props.keyword,
      active: props.active,
      editors_choice: props.editors_choice,
      vintage: props.vintage,
      per_page: props.per_page,
      sort_by: props.sort_by,
    }
    this._handleOnChangeInput = this._handleOnChangeInput.bind(this);
    this._handleApplyFilterButtonClick = this._handleApplyFilterButtonClick.bind(this);
    this._handleOnChangeInputAndApply = this._handleOnChangeInputAndApply.bind(this);
    this._handleSearchButtonClick = this._handleApplyFilterButtonClick.bind(this);
  }

  _handleOnChangeInput(e){
    const lastState = {...this.state};
    lastState[e.target.name] = e.target.value;
    this.setState({...lastState});
  }

  _handleOnChangeInputAndApply(e){
    const lastState = {...this.state};
    lastState[e.target.name] = e.target.value;
    this.setState({...lastState}, ()=> this._handleSubmitFilter());
  }

  _handleApplyFilterButtonClick(e){
    e.preventDefault();
    this._handleSubmitFilter();
  }

  _handleSubmitFilter(){
    const { keyword, active, editors_choice, vintage, per_page, sort_by } = this.state;
    this.props.onApplyFilter({ keyword, active, editors_choice, vintage, per_page, sort_by });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.isReset && this.props.isReset!==nextProps.isReset){
      const { keyword, active, editors_choice, vintage, per_page, sort_by } = nextProps;
      this.setState({
        keyword,
        active,
        editors_choice,
        vintage,
        per_page,
        sort_by
      })
      this.props.onResetFilterCallback();
    }
  }

  render(){
    // console.log('Rerender Filters')
    return(
      <Collapse isOpen={this.props.isOpen}>
        <CardBody className="filter-container__card-body">
          <SearchForm
            keyword = {this.state.keyword}
            onInputChange = {this._handleOnChangeInput}
            onSubmit = {this._handleSearchButtonClick}
          />
          <FilterForm
            active = {this.state.active}
            editors_choice = {this.state.editors_choice}
            vintage = {this.state.vintage}
            onCheckedChange= {this._handleOnChangeInput}
            onSubmit = {this._handleApplyFilterButtonClick}
          />
          <hr/>
          <SortForm
            per_page={this.state.per_page}
            sort_by={this.state.sort_by}
            sortOptions={this.props.sortOptions}
            onInputChange={this._handleOnChangeInputAndApply}
          />
        </CardBody>
      </Collapse>
    )
  }
}

Filters.propTypes= {
  keyword: propTypes.string,
  per_page: propTypes.oneOfType([propTypes.number, propTypes.string]),
  sort_by: propTypes.string,
  isOpen: propTypes.bool.isRequired,
  onHandleChange: propTypes.func,
  onHandleChangeAndSubmit: propTypes.func,
  onHandleSearchClick: propTypes.func
}

Filters.defaultProps= {
  keyword: '',
  active: '',
  editors_choice: '',
  vintage: '',
  per_page: 15,
  sort_by: '',
}